<template>
  <v-col
    v-if="canAccessKioskActions"
    cols="auto"
  >
    <v-row>
      <v-col>
        <v-tooltip
          v-if="currentUser.isAdmin"
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              v-bind="attrs"
              icon
              v-on="on"
              @click="_ => onShowKioskActionsDialog()"
            >
              <v-icon>
                mdi-account-convert
              </v-icon>
            </v-btn>
          </template>
          <span>Kiosk Status: {{ peParty.kiosk_status }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <KioskActionsDialog v-model="showKioskActionsDialog" />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'
import { PARTY_NAMESPACE } from '@/store/party'

import KioskActionsDialog from '@/components/Dialogs/Party/KioskActionsDialog'

export default {
  name: 'KioskActions',

  components: {
    KioskActionsDialog,
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      showKioskActionsDialog: false,
    }
  },

  computed: {
    canAccessKioskActions () {
      return (
        this.currentUser.isAdmin &&
          this.peParty.is_eco_member &&
          this.isKioskEnabled &&
          this.peParty.kiosk_status !== null
      )
    },

    ...mapGetters([
      'currentUser',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),

    ...mapGetters(INTEGRATION_NAMESPACE, [
      'isKioskEnabled',
    ]),
  },

  created () {
    this.checkKioskEnabled()
  },

  methods: {
    onShowKioskActionsDialog () {
      this.showKioskActionsDialog = true
    },

    ...mapActions(INTEGRATION_NAMESPACE, [
      'checkKioskEnabled',
    ]),
  },
}
</script>
